var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 d-flex justify-content-center"},[_c('div',{staticClass:"video-container"},[_c('video-player',{ref:"player",staticClass:"video-player",attrs:{"options":_vm.playerOptions,"playsinline":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }